__turbopack_context__.v({
  "articleLayout": "layouts-module__mzYk8q__articleLayout",
  "baseLayout": "layouts-module__mzYk8q__baseLayout",
  "blogLayout": "layouts-module__mzYk8q__blogLayout",
  "centeredLayout": "layouts-module__mzYk8q__centeredLayout",
  "contentLayout": "layouts-module__mzYk8q__contentLayout",
  "downloadLayout": "layouts-module__mzYk8q__downloadLayout",
  "homeLayout": "layouts-module__mzYk8q__homeLayout",
  "postLayout": "layouts-module__mzYk8q__postLayout",
});
